



































































































import {
  MemberManagementMemberHistoryService as memberHistoryApi,
  MemberManagementMemberPointService as memberPointApi,
} from "@/common/api";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import MemberOrderInfoComponent from "@/components/admin/member/memberOrderInfoComponent.vue";
import MemberPointHistoryComponent from "@/components/admin/member/memberPointHistoryComponent.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import { TYPES_ARRAY } from "@/model/order";
import PaginateModel from "@/model/paginate";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberOrderHistoryComponent",
  components: {
    QErrors,
    QTableHeader,
    QPaginate,
    QMultiSelect,
    QCalendar,
    MemberPointHistoryComponent,
    MemberOrderInfoComponent,
  },
})
export default class MemberOrderHistoryComponent extends Vue {
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public memberId = null;

  public remainPoints = 0;

  public headers = [];

  public initHeaders = [
    { id: "created_at", name: "購入日", order: "desc" },
    { id: "order_code", name: "注文", order: "" },
    { id: "type", name: "カテゴリ" },
    { id: "sub_total", name: "注文小計" },
    { id: "shipping_fee", name: "送料" },
    { id: "s_point", name: "pt利用S" },
    { id: "l_point", name: "pt利用L" },
    { id: "total", name: "支払額" },
    { id: "", name: "" },
    { id: "", name: "" },
  ];

  public initSearch = {
    types: ["all"],
    startDate: null,
    endDate: null,
    orderCode: null,
    sort: "created_at",
    direction: "desc",
    perPage: 30,
    currentPage: 1,
  };

  public searchParams: any = {};

  public selectedAllType = { id: "all", name: "すべての購入履歴" };
  public searchTypeOptions = [...[this.selectedAllType], ...TYPES_ARRAY];

  public orderHistories = [];

  public dateConfig = {
    dateFormat: "Y-m-d",
    enableTime: false,
    allowInput: false,
  };

  public async show() {
    this.memberId = this.$router.currentRoute.params?.id;
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.initalSearch();
    if (this.memberId) {
      const requests: any = [
        memberPointApi.adminMemberPointRemainPoints({
          member_id: this.memberId,
        }),
        this.filterData(),
      ];
      const result: any = await Promise.all(requests);
      result[0] && (this.remainPoints = result[0].data.remain_points);
      // this.filterData();
    }
  }

  public initalSearch(): void {
    let query = this.$router.currentRoute.query;
    query = this.formatQueryToArray(query, "types");
    this.searchParams = {
      ...this.initSearch,
      ...query,
    };
  }
  public formatQueryToArray(query, name) {
    if (query[name]) {
      query[name] = Array.isArray(query[name]) ? query[name] : [query[name]];
    }
    return query;
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query, hash } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    this.$router
      .replace({ name, params, query, hash })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    let message: any;
    try {
      if (query.types && query.types.includes("all")) {
        query.types = [];
      }

      if (query.statuses && query.statuses.includes("all")) {
        query.statuses = [];
      }
      const result = await memberHistoryApi.adminMemberHistory({
        ...query,
        ...{
          memberId: this.memberId,
        },
      });
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.orderHistories = result.data.orders;
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initSearch };
  }

  public showPointHistories() {
    (this.$refs
      .memberPointHistoryComponent as MemberPointHistoryComponent).show(
      this.memberId,
    );
  }

  public showOrderInfo(orderId) {
    (this.$refs.memberOrderInfoComponent as MemberOrderInfoComponent).show(
      orderId,
    );
  }

  public async updateRemainPoints() {
    const result = await memberPointApi.adminMemberPointRemainPoints({
      member_id: this.memberId,
    });
    this.remainPoints = result.data.remain_points;
  }
}
